<kt-base-modal [title]="'Task Activity'">
  <div modal-body class="p-0">
    <kt-loader [showLoader]="loading()">

      @if (!loading() && noAccess()) {
        <kt-no-record-found [noRecordFound]="noAccessRecord"></kt-no-record-found>
      } @else if (!loading() && !hasOpenShift()) {
        <kt-no-record-found [noRecordFound]="noShiftNoRecord"></kt-no-record-found>
      } @else {

        <div class="ta-toolbar px-4 pt-3 pb-2">
          <div class="ta-progress">
            <div class="ta-progress__track">
              <div class="ta-progress__fill" [style.width.%]="progressPercent()"></div>
            </div>
            <span class="ta-progress__text">
              {{ doneTodayCount() }}/{{ todayTasks().length }} done · {{ progressPercent() }}%
            </span>
          </div>

          <button type="button" class="btn btn-label-brand btn-sm btn-icon white-config-color-hover"
            [disabled]="loading()" (click)="refresh()" ngbTooltip="Refresh" triggers="hover" container="body">
            <svg-icon src="assets/media/iq-svg/without_circle/icon_set_3/refresh.svg"></svg-icon>
          </button>
        </div>

        <div class="ta-tabs px-4">
          @for (tab of tabs; track tab.value) {
            <button type="button" class="ta-tab" [class.ta-tab--active]="activeTab() === tab.value"
              (click)="setTab(tab.value)">
              {{ tab.label }}<span class="ta-tab__count">{{ tabCount(tab.value) }}</span>
            </button>
          }
        </div>

        <!-- Why nothing can be ticked (e.g. on a break): a full-width strip under the tabs, as in the app -->
        @if (readOnly && readOnlyReason) {
          <div class="ta-readonly px-4" role="status">{{ readOnlyReason }}</div>
        }

        <div class="ta-body px-4 pb-4">
          @if (!visibleGroups().length) {
            <kt-no-record-found [noRecordFound]="noTasksNoRecord"></kt-no-record-found>
          }

          @for (group of visibleGroups(); track trackGroup($index, group)) {
            <div class="ta-group">
              <div class="ta-group__head" (click)="toggleGroup(group)">
                <span class="ta-group__chev">{{ isCollapsed(group) ? '&#9654;' : '&#9660;' }}</span>
                <span class="ta-group__name" triggers="hover" container="body">{{ shorten(group.advance_task_group_name, groupNameMax) }}</span>
                <span class="ta-chip ta-chip--scope">
                  {{ group.advance_task_group_scope_type === 'AREA' ? businessLabel.Area : businessLabel.Location }}
                </span>
                <span class="ta-chip">
                  {{ group.advance_task_group_completion_type === 'SHARED' ? 'Shared' : 'Individual' }}
                </span>
                @if (groupDueCount(group)) {
                  <span class="ta-group__count">{{ groupDoneCount(group) }}/{{ groupDueCount(group) }}</span>
                }
              </div>

              @if (!isCollapsed(group)) {
                @for (section of visibleSections(group); track trackSection($index, section)) {
                  <!-- Like the prototype's section header (.er-sec): name, then done / tasks shown. Tasks with
                       no section get one too, so it is clear they belong to the group rather than the section above. -->
                  <div class="ta-section">
                    <span class="ta-section__name">
                      {{ section.advance_task_section_id === null ? standaloneLabel : section.advance_task_section_name }}
                    </span>
                    <span class="ta-section__count">{{ sectionDoneCount(section) }}/{{ visibleTasks(section).length }}</span>
                  </div>

                  @for (task of visibleTasks(section); track trackTask($index, task)) {
                    <div class="ta-row" [class.ta-row--done]="task.is_done">

                      <label class="kt-checkbox kt-checkbox--single kt-checkbox--brand ta-check"
                        [class.kt-checkbox--disabled]="!canTick(task)"
                        [ngbTooltip]="tickTooltip(task)" triggers="hover" container="body">
                        <!-- preventDefault: the box ticks only once the server confirms, via [checked] -->
                        <input type="checkbox" [checked]="task.is_done" [disabled]="!canTick(task)"
                          (click)="$event.preventDefault(); toggleTask(task)" />
                        <span></span>
                      </label>

                      <div class="ta-row__main">
                        <div class="ta-row__title">
                          <span class="ta-row__name" [ngbTooltip]="task.advance_task_name" triggers="hover"
                            container="body">{{ shorten(task.advance_task_name, taskNameMax) }}</span>
                          <span class="ta-freq">{{ '(' + frequencyLabel(task) + ')' }}</span>
                        </div>

                        <div class="ta-row__meta">
                          @if (guidanceTimeLabel(task)) {
                            <span>{{ guidanceTimeLabel(task) }}</span>
                          }
                          @if (task.is_done) {
                            <span class="ta-row__by">
                              {{ completedLabel(task) }}
                            </span>
                          }
                        </div>

                        @if (task.advance_task_instructions) {
                          <div class="ta-row__instructions">{{ task.advance_task_instructions }}</div>
                        }
                      </div>

                      @if (priorityColour(task)) {
                        <span class="ta-priority" [style.background-color]="priorityColour(task)"
                          [ngbTooltip]="task.advance_task_priority + ' priority'" triggers="hover"
                          container="body"></span>
                      }

                      <!-- Count bubble like the prototype's (.note-n), only when there are comments -->
                      <button type="button" class="ta-comment" [class.ta-comment--has]="task.comment_count > 0"
                        (click)="commentsClick(task)" ngbTooltip="Comments &amp; photos" triggers="hover" container="body">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                          width="15" height="15">
                          <path stroke-linecap="round" stroke-linejoin="round"
                            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                        </svg>
                        @if (task.comment_count > 0) {
                          <span class="ta-comment__count">{{ task.comment_count }}</span>
                        }
                      </button>
                    </div>
                  }
                }
              }
            </div>
          }
        </div>
      }
    </kt-loader>
  </div>
</kt-base-modal>
